import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { SCROLL_TO_PRICING_STATE } from "../utils/scrollToPricing";

const useGoToPricing = () => {
  const navigate = useNavigate();

  return useCallback(() => {
    navigate("/", { state: SCROLL_TO_PRICING_STATE });
  }, [navigate]);
};

export default useGoToPricing;
